import {BaseSpringServiceCB} from "@aiknow-srl/aik-ngx-http";
import {DiagnosticOPEEnum} from "./DiagnosticOPEEnum";

/**
 * O Inner Class
 */
class O {
  events: AlarmEventDTO[];

  constructor() {
    this.events = [];
  }
}

class AlarmEventDTO {
  ts!: Date;
  alarmStatusValue!: number;
  message!: string;
}

export class DateIntervalDTO {
  fromTs!: number;
  toTs!: number;
}

class I {
  partitionId!: number;
  originEntityName!: string;
  entityId!: number;
  lastEvents: boolean = false;
  lastEventsNumber?: number;
  dateInterval?: DateIntervalDTO;
}


export class GetDiagnosticEventsCB extends BaseSpringServiceCB {
  /**
   * Input
   */
  public i: I;
  /**
   * Output
   */
  public o: O;

  /**
   * Class constructor
   */
  constructor() {
    super(DiagnosticOPEEnum.GetDiagnosticEvents);
    this.i = new I();
    this.o = new O();
  }
}
